<template>
  <div id="app">
    <header>
      <div class="container">
        <router-link
          to="/"
          class="logo"
        >
          Pokémon Data
          <span class="alpha">alpha</span>
        </router-link>
        <div class="links">
          <router-link
            class="link has-text-info"
            to="/pokemon/list"
          >Pokémon list</router-link>
          <router-link
            class="link has-text-info"
            to="/abilities"
          >Abilities list</router-link>
          <a
            :href="links.forum"
            class="link has-text-info"
            target="_blank"
          >Community</a>
        </div>
        <div class="right">
          <div class="has-text-grey">
            <!-- <span class="icon is-small">
              <i class="mdi mdi-magnify"></i>
            </span> -->
            <span>[type to search]</span>
          </div>
        </div>
      </div>
    </header>
    <search></search>
    <main>
      <div class="container">
        <div v-if="loading">
          <div class="sk-fading-circle">
            <div class="sk-circle1 sk-circle"></div>
            <div class="sk-circle2 sk-circle"></div>
            <div class="sk-circle3 sk-circle"></div>
            <div class="sk-circle4 sk-circle"></div>
            <div class="sk-circle5 sk-circle"></div>
            <div class="sk-circle6 sk-circle"></div>
            <div class="sk-circle7 sk-circle"></div>
            <div class="sk-circle8 sk-circle"></div>
            <div class="sk-circle9 sk-circle"></div>
            <div class="sk-circle10 sk-circle"></div>
            <div class="sk-circle11 sk-circle"></div>
            <div class="sk-circle12 sk-circle"></div>
          </div>
        </div>
        <router-view v-else />
      </div>
    </main>
    <footer class="footer">
      <div class="content has-text-centered">
        <div id="copyright">
          <!-- Pokémon © 2002-{{currentYear}} Pokémon. © 1995-{{currentYear}} Nintendo/Creatures Inc./GAME FREAK inc. TM, ® and Pokémon character names are trademarks of Nintendo.
          <br>
          Pokémon, Pikachu and all other elements of the Pokémon franchise are and remain © 1995-2008 Nintendo, GAME FREAK and Creatures. Inc.
          <br>
          Pokémon And All Respective Names are Trademark & © of Nintendo 1996-{{currentYear}}
          <br>
          Pokémon, pokemon images and its trademarks are ©1995-{{currentYear}} Nintendo, GAME FREAK inc. TM, ® and Creatures Inc.
          <br> -->
          Pokémon and all elements of the Pokémon franchise are ©1995-{{currentYear}} Nintendo, GAME FREAK inc. TM ® and Creatures Inc.
          <br>
          All other content are ©{{currentYear}} PokemonData.com
        </div>
        <p>version {{version}}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import config from './config'
import { mapActions } from 'vuex'
import search from './components/pages/Search'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'app',
  data() {
    return {
      loading: true,
      version: require('../package.json').version,
      currentYear: moment().get('year'),
      links: config.links,
    }
  },
  components: {
    search,
  },
  mounted() {
    (async () => {
      const simpleList = await axios.get('/data/search.pokemon.json')
      const pokemonTypes = await axios.get('/data/pokemon.types.json')
      const typeEfficacy = await axios.get('/data/type-efficacy.json')
      const itemsSimpleList = await axios.get('/data/search.item.json')
      const abilitiesSimpleList = await axios.get('/data/abilities.json')
      const moveList = await axios.get('/data/moves.json')
      const moveMethods = await axios.get('/data/move-methods.json')
      const moveEffects = await axios.get('/data/move-effects.json')
      const moveTargets = await axios.get('/data/move-targets.json')
      const versions = await axios.get('/data/versions.json')

      Promise.all([simpleList, pokemonTypes, typeEfficacy, itemsSimpleList, abilitiesSimpleList, moveList, moveMethods, moveEffects, moveTargets, versions]).then(values => {
        this['pokemon/setSimpleList'](values[0].data)
        this['pokemon/setTypes'](values[1].data)
        this['pokemon/setTypeEfficacy'](values[2].data)
        this['item/setSimpleList'](values[3].data)
        this['abilities/setSimpleList'](values[4].data)
        this['moves/setList'](values[5].data)
        this['moves/setMethods'](values[6].data)
        this['moves/setEffects'](values[7].data)
        this['moves/setTargets'](values[8].data)
        this['versions/setList'](values[9].data)
        this.loading = false
      })
    })()
  },
  methods: {
    ...mapActions([
      'pokemon/setSimpleList',
      'pokemon/setTypes',
      'pokemon/setTypeEfficacy',
      'item/setSimpleList',
      'abilities/setSimpleList',
      'moves/setList',
      'moves/setMethods',
      'moves/setEffects',
      'moves/setTargets',
      'versions/setList',
    ]),
  },
}
</script>

<style lang="scss">
@import 'assets/css/bulma-custom.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  main {
    flex: 1;
    margin: 20px 0;
  }
  header {
    background-color: $black-bis;
    padding: 2px 0 5px;
    margin-bottom: 20px;
    .container {
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      align-items: center;
    }
    color: $white;
    .logo {
      font-size: 2rem;
      font-weight: 700;
      color: $white;
      .alpha {
        font-size: 14px;
        font-weight: 400;
        font-style: italic;
        color: $blue;
        // color: $white;
        // padding: 0px 5px;
        // line-height: 15px;
      }
    }
    .links {
      margin: 0 15px;
      padding: 0 15px;
      .link {
        margin-right: 20px;
      }
    }
    .right {
      margin-left: auto;
    }
  }
  .footer {
    background-color: $black;
    margin-top: 20px;
    #copyright {
      width: 100%;
      // position: fixed;
      // bottom: 0;
      // left: 0;
      font-weight: 700;
      text-align: center;
      z-index: 1000;
      color: $white;
      padding: 10px 0;
    }
  }
}

.pokemon-type {
  min-width: 80px;
  border-radius: 3px;
  padding: 0 0 1px;
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 700 !important;
  // color:#fff;
  border-width: 1px;
  border-style: solid;
  margin: 0 2px 0 0;

  display: inline-block;
  // height:20px;
  line-height: 18px;
  text-align: center;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  cursor: pointer;
  &.inactive {
    background-color: transparent !important;
    color: $white !important;
    border-color: $white !important;
  }
}

.pokemon-type-small {
  @extend .pokemon-type;
  min-width: 50px;
  font-weight: 500 !important;
  font-size: 10px;
  height: 14px;
  line-height: 12px;
}
.pokemon-type-large {
  @extend .pokemon-type;
  min-width: 100px;
  margin: 0 5px 0 0;
  // min-width: 50px;
  // font-weight: 500 !important;
  font-size: 16px;
  height: 30px;
  line-height: 26px;
}

@keyframes shiny {
  0% {
    left: -150px;
    top: -50px;
    transform: rotate(0deg);
  }
  90% {
    left: 80px;
    top: -20px;
    transform: rotate(30deg);
  }
  100% {
    left: 82px;
  }
}

.shiny-pokemon-type {
  content: '';
  width: 40px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.4);
  position: absolute;
  border-radius: 50%;
  animation: shiny 1s infinite;
}

@for $i from 1 through length($ptypes) {
  .pokemon-type-#{nth($ptypes, $i)} {
    // background-color: nth($ptypecolors, $i);
    background-color: nth(map-get($colors, 'type-#{nth($ptypes, $i)}'), 1);
    // color: findColorInvert(nth($ptypecolors, $i));
    color: nth(map-get($colors, 'type-#{nth($ptypes, $i)}'), 2);
    border-color: darken(nth(map-get($colors, 'type-#{nth($ptypes, $i)}'), 1), 10%);
    &:hover {
      border-color: darken(nth(map-get($colors, 'type-#{nth($ptypes, $i)}'), 1), 30%);
    }
    &.eff-400 {
      // border-width:2px;
      &:after {
        @extend .shiny-pokemon-type;
      }
      &:before {
        @extend .shiny-pokemon-type;
        background-color: rgba(255, 255, 255, 0.2);
        animation-delay: 0.1s;
      }
    }
    &.eff-200 {
      &:after {
        @extend .shiny-pokemon-type;
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    &.eff-100 {
    }
    &.eff-50 {
    }
    &.eff-25 {
    }
  }
}

.b-table .table tr.detail {
  background-color: $grey-darker !important;
  box-shadow: none !important;
}

.sk-fading-circle {
  margin: auto;
  width: 60px;
  height: 60px;
  position: relative;
}

.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-fading-circle .sk-circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #fff;
  border-radius: 100%;
  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
  animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  transform: rotate(30deg);
}
.sk-fading-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  transform: rotate(60deg);
}
.sk-fading-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.sk-fading-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  transform: rotate(120deg);
}
.sk-fading-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  transform: rotate(150deg);
}
.sk-fading-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.sk-fading-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
  -ms-transform: rotate(210deg);
  transform: rotate(210deg);
}
.sk-fading-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
  -ms-transform: rotate(240deg);
  transform: rotate(240deg);
}
.sk-fading-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.sk-fading-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
  -ms-transform: rotate(300deg);
  transform: rotate(300deg);
}
.sk-fading-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
  transform: rotate(330deg);
}
.sk-fading-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.sk-fading-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

@keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
</style>
